import React, { FC, useEffect,useState } from "react";
import CookieConsent from "react-cookie-consent";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import Header from "src/containers/Header";
import Footer from "src/containers/Footer";
import SideDrawer from "src/components/SideDrawer";
import MobileMenu from "src/components/MobileMenu";
import NotificationBar from "src/components/NotificationBar";
// import { CartDrawer } from "src/components/cartDrawer";
import { StyledWrap } from "./styles"
import "src/styles/main.scss";
// import "../styles/fonts.css";
import { isSSR } from "src/utils/ssr";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";

const Layout: FC = ({ children, siteMetadata, location, pageContext }) => {
  const socialIcons = pageContext?.social && pageContext.social.length > 0 ? pageContext.social[0].options : null;

  const SEO = () => {
    if (typeof window !== "undefined") {
      const isLiveDomain = window.location.hostname === new URL(process.env.GATSBY_URL).hostname;
      if (!isLiveDomain) {
        return (
          <Helmet>
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
        )
      }
    }
    
    return null;
  };

  useEffect(() => {
    if (isSSR) return;

    const country = process.env.GATSBY_CURRENCY_SYMBOL
    const chatWidget = document.getElementById("gorgias-chat-container");

    if ((pageContext?.slug === "contact" || pageContext?.slug === "returns") && country == "£") {
      if (chatWidget != null) {
        chatWidget.style.display = "block";
      }
    } else {
      if (chatWidget != null) {
        chatWidget.style.display = "none";
      }
    }

  }, [pageContext?.slug])

  const updateClarityConsent = (granted: boolean) => {
    if (typeof window === "undefined" || !("clarity" in window)) return;

    window.clarity("consentv2", {
      ad_Storage: granted ? "granted" : "denied",
      analytics_Storage: granted ? "granted" : "denied",
    });
  };

  // const handleConsentChange = (granted: boolean, location) => {
  //   const value = granted ? "true" : "false";

  //   Cookies.set("gatsby-gdpr-google-analytics", value, { path: "/", expires: 365 });
  //   Cookies.set("gatsby-gdpr-google-tagmanager", value, { path: "/", expires: 365 });

  //   if (typeof window !== "undefined") {
  //     window.dataLayer = window.dataLayer || [];

  //     if (typeof window.gtag === "function") {
  //       window.gtag("consent", "update", {
  //         ad_storage: granted ? "granted" : "denied",
  //         analytics_storage: granted ? "granted" : "denied",
  //       });
  //     } else {
  //       window.dataLayer.push({
  //         event: "consent_update",
  //         ad_storage: granted ? "granted" : "denied",
  //         analytics_storage: granted ? "granted" : "denied",
  //       });
  //     }
  //   }

  //   updateClarityConsent(granted);

  //   if (granted) {
  //     initializeAndTrack(location);
  //   }
  // };
  
  return (
    <>
    <SEO />
    <React.Fragment>
      <StyledWrap>
        {pageContext.notificationBar && (
          <NotificationBar
            enabled={pageContext.notificationBar[0].enabled}
            whiteTextDesktop={pageContext.notificationBar[0].whiteTextDesktop}
            yellowTextDesktop={pageContext.notificationBar[0].yellowTextDesktop}
            whiteTextMobile={pageContext.notificationBar[0].whiteTextMobile}
            yellowTextMobile={pageContext.notificationBar[0].yellowTextMobile}
            discountName={pageContext.notificationBar[0].discountName}
            countdownDate={pageContext.notificationBar[0].countdownDate}
          />
        )}
        <Header
          transparent={
            pageContext._type !== "productsShopify" &&
            pageContext._type !== "collection" &&
            pageContext._type !== undefined
          }
          notificationBar={
            pageContext.notificationBar
              ? pageContext.notificationBar[0].enabled
              : false
          }
          data={
            pageContext.mobileMenu
            ? pageContext.mobileMenu[0]
            :false 
          }
          afterTheLineItems={
            pageContext?.menus 
            ? pageContext.menus[0].afterTheLineItems 
            :false 
          }
        />
      </StyledWrap>
      {pageContext.cartInfo && (
        <SideDrawer returnMoneyBack={pageContext?.returnMoneyBack[0]?.drawer?.content} cartInfo={pageContext.cartInfo[0]} additionalInformationImage={pageContext.main?.additionalInformationImage} productCases={pageContext?.main?.productCases} caseText={pageContext?.main?.caseText} caseSubheader={pageContext?.main?.caseSubheader} />
      )}
      {pageContext.mobileMenu && (
        <MobileMenu data={pageContext.mobileMenu[0]} />
      )}
      <main>
        {children}
        <Footer socialIcons={socialIcons}/>
      </main>
      <CookieConsent
        enableDeclineButton
        onAccept={() => {
          updateClarityConsent(true);
          initializeAndTrack(location);
        }}
        onDecline={() => {
          updateClarityConsent(false);
        }}
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        declineButtonStyle={{
          width: "115px",
          padding: "0 3.3rem",
          backgroundColor: "grey",
        }}
        buttonStyle={{
          width: "115px",
          padding: "0 3.3rem",
          backgroundColor: "rgb(231, 116, 120)",
          height: "5rem",
        }}
        cookieName="gatsby-gdpr-google-analytics"
      >
        We use cookies to ensure you get the best experience on our website.
      </CookieConsent>
    </React.Fragment>
    </>
  );
};

export default Layout;
